require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-biomechanics-perspective.json") })
        }
      }, "path---blog-biomechanics-perspective");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-biomechanics-perspective!./.cache/json/blog-biomechanics-perspective.json
// module id = 279
// module chunks = 231608221292675